// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum Roles {
    AccessTestEnvironment = 'accessTestEnvironment',
    AfasAuth = 'afasAuth',
    AiReports = 'aiReports',
    Codalt = 'codalt',
    Employee = 'employee',
    EmployeeBlast = 'employeeBlast',
    EmployeeInventorize = 'employeeInventorize',
    EmployeeMarkings = 'employeeMarkings',
    EmployeeWipe = 'employeeWipe',
    Foreman = 'foreman',
    FormerEmployee = 'formerEmployee',
    Hourcheck = 'hourcheck',
    HourcheckRestricted = 'hourcheckRestricted',
    HoursExtended = 'hoursExtended',
    Hourwriter = 'hourwriter',
    Hrm = 'hrm',
    Kam = 'kam',
    Leave = 'leave',
    LeaveManagement = 'leaveManagement',
    Management = 'management',
    Office = 'office',
    OtherEmployees = 'otherEmployees',
    Planner = 'planner',
    PlanningAlwaysRead = 'planningAlwaysRead',
    ProjectManagement = 'projectManagement',
    Projectmanager = 'projectmanager',
    UserManagement = 'userManagement',
}
